export enum EImportance {
    Faible = 1,
    Forte = 2,
    Presence = 3,
}